import React, { createContext, useContext, useState, useCallback } from 'react';

const AsaContext = createContext();

export const useAsa = () => {
  const context = useContext(AsaContext);
  if (!context) {
    throw new Error('useAsa must be used within an AsaProvider');
  }
  return context;
};

export const AsaProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contextData, setContextData] = useState(null);
  const [contextType, setContextType] = useState(null);

  const openAsa = useCallback((type, data) => {
    setContextType(type);
    setContextData(data);
    setIsOpen(true);
  }, []);

  const closeAsa = useCallback(() => {
    setIsOpen(false);
    // Kita tidak menghapus contextData agar percakapan tetap nyambung walau widget diminimize
  }, []);

  return (
    <AsaContext.Provider value={{ isOpen, contextData, contextType, openAsa, closeAsa }}>
      {children}
    </AsaContext.Provider>
  );
};
